import React from "react";
import Button from "../../form/Button";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import Input from "../../form/Input";
import Tags from "../../form/Tags";

const SendMessagePopup = () => {
  return (
    <div className="absolute bottom-10 right-10 w-fit h-fit">
      <Popover className="relative">
        <PopoverButton
          className={
            "bg-chestnut-rose flex items-center justify-center rounded-lg w-14 h-14"
          }
        >
          <i className="fa-solid fa-message-plus text-2xl text-white"></i>
        </PopoverButton>
        <PopoverPanel
          anchor="left"
          className="flex flex-col [--anchor-gap:4px] sm:[--anchor-gap:8px]"
        >
          <div className="bg-white h-[500px] w-[400px] mb-4 rounded-xl shadow flex flex-col">
            <div>
              <Tags />
            </div>
          </div>
        </PopoverPanel>
      </Popover>
    </div>
  );
};

export default SendMessagePopup;
